import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";

/** Enums */
import UserRoles from "../enums/UserRoles.ENUM";

/** Utilities */
import { useMenu } from "../context/MenuContext";
import { getAuthProps } from "../utils/authentication/authLibrary";
import { encryptUrlData } from "../utils/encryption/CryptoService";

/** Components */
import GlobalSearch from "../components/common/GlobalSearch/GlobalSearch";
import NotificationBell from "../components/common/notifications/NotificationBell";
import InterviewSlotsCalendar from "../components/common/InterviewSlotsCalendar/InterviewSlotsCalendar";

/** CSS */
import "./Header.scss";

const Header = ({ toggleSidebar }) => {

  const calendarOverlayRef = useRef(null);

  const { showAdminMenu, toggleAdminMenu } = useMenu();

  const navigate = useNavigate();
  const authData = getAuthProps();

  const userInfo = authData?.user;
  const userFullName = [userInfo?.firstName].filter(Boolean).join(" ") || "User";
  const organizationId = authData?.organizationId;
  const userRoleId = authData?.roles?.roleId;

  const handleAdminMenuToggle = () => {
    toggleAdminMenu();
    const navPath = showAdminMenu
      ? "/"
      : `/organization-details/${encryptUrlData(organizationId)}`;
    navigate(navPath);
  };

  const handleProfileClick = () => {
    navigate(`/profile/${encryptUrlData(userInfo?.userId)}`);
  }

  return (
    <div className="header-container">
      <div className="left-section">
        <button
          type="button"
          className="pi pi-align-right toggle-bar"
          style={{
            marginLeft: "auto",
            cursor: "pointer",
            background: "none",
            border: "none",
          }}
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
        ></button>
        <GlobalSearch />
      </div>
      <div className="middle-section"></div>
      <div className="right-section">
        <div className="btn-section">
          <span className="btn-container">
            {userRoleId !== UserRoles.INTERVIEWER && (
              <Button
                outlined
                onClick={() => navigate("/deleted-applicants")}
                tooltip="Recycle Bin"
                data-pr-position="bottom"
                icon="pi pi-trash"
              />
            )}
            <NotificationBell userInfo={userInfo} />
            <Button
              outlined
              tooltip="Interviews"
              data-pr-position="bottom"
              icon="pi pi-calendar"
              onClick={(e) => calendarOverlayRef.current?.toggle(e)}
            />
            <OverlayPanel ref={calendarOverlayRef} dismissable className="interview-slots-overlay">
              <InterviewSlotsCalendar />
            </OverlayPanel>

            {userRoleId === UserRoles.ADMIN && (
              <Button
                onClick={handleAdminMenuToggle}
                outlined
                tooltip={showAdminMenu ? "Home" : "Administration"}
                data-pr-position="bottom"
                icon={showAdminMenu ? "pi pi-home" : "pi pi-cog"}
                key={showAdminMenu ? "admin" : "home"}
              />
            )}

            <span className="user-menu">
              <div className="right-user">
                <Button
                  outlined
                  icon="pi pi-user"
                  onClick={handleProfileClick}
                  tooltip="Profile"
                  data-pr-position="bottom"
                >
                </Button>
                <div className="user-name">
                  <span className="name">{userFullName}</span>
                </div>
              </div>
            </span>
          </span>
        </div>
      </div>
    </div >
  );
};

Header.propTypes = {
  toggleSidebar: PropTypes.func.isRequired,
};

export default Header;
